import axios from 'axios';
import camelize from './camelize';
import snakeize from './snakeize';
const myaxios = {
    get: async (url, config) => {
        const response = await axios.get(url, config);
        response.data = camelize(response.data);
        return response;
    },
    post: async (url, body, config) => {
        const response = await axios.post(url, snakeize(body), config);
        response.data = camelize(response.data);
        return response;
    },
    patch: async (url, body, config) => {
        const response = await axios.patch(url, snakeize(body), config);
        response.data = camelize(response.data);
        return response;
    },
    delete: async (url, config) => {
        const response = await axios.delete(url, config);
        response.data = camelize(response.data);
        return response;
    },
    put: async (url, body, config) => {
        return axios.put(url, body, config);
    },
};
export default myaxios;
